import './websharebutton.component.scss';

class WebShareButtonController {
    constructor($scope) {
        'ngInject';
        
        this.available = false;
    }

    get shareData() {
        return {
            title: this.title,
            text: this.title,
            url: this.url
        };
    }

    $onInit() {
        if (navigator.share)
            this.available = true;
    }

    share() {
        navigator.share(this.shareData)
            .then(() => console.log('WebShareButtonController::share -> success', this.shareData))
            .catch((error) => console.log('WebShareButtonController::share -> error', error));
    }
}

let webShareButtonComponent = {
    bindings: {
        url: '@',
        title: '@',
        text: '@'
    },
    template: '<button type="button" ng-show="$ctrl.available" ng-click="$ctrl.share()" title="{{ $ctrl.text }}"><svg width="14" height="14"><use xlink:href="/templates/dobrazima/dist/spritemap.svg#sprite-share-icon"></use></svg></button>',
    controller: WebShareButtonController
}

export default webShareButtonComponent;